import type { ComponentType, ReactNode } from "react";
import * as VegaIcons from "vega-icons";

const VEGA_ICONS: Record<string, ComponentType<{ className?: string }>> = {
  ...VegaIcons,
};

export const resolveVegaIcon = (iconName?: string): ReactNode => {
  const Icon = iconName ? VEGA_ICONS[iconName] : undefined;

  return Icon ? <Icon /> : undefined;
};
